<script>
	export let data;

	import { cloneDeep } from "lodash-es";

	import { localUrl } from "../../../../scripts/is_local";
	import { customAlert } from "../../../../scripts/custom_alert";

	import {
		isMobile,
		specialistsIDs,
		specialistsAddArr,
		SpecialistPremodDone,
		saved,
		changed,
		isNewDataChanged,
	} from "../../../../stores/variables";

	import Input from "./form_modal/Input.svelte";
	import Textarea from "./form_modal/Textarea.svelte";
	import Image from "./form_modal/Image.svelte";
	import Ranks from "./form_modal/Ranks.svelte";
	import Specialities from "./form_modal/Specialities.svelte";
	// import AddToMoreClinics from "./form_modal/AddToMoreClinics.svelte";
	import Multiple from "./form_modal/Multiple.svelte";

	let componentList = [
		{
			ID: "Input",
			component: Input,
		},
		{
			ID: "Textarea",
			component: Textarea,
		},
		{
			ID: "Multiple",
			component: Multiple,
		},
		{
			ID: "Image",
			component: Image,
		},
		// {
		// 	ID: "AddToMoreClinics",
		// 	component: AddToMoreClinics,
		// },
		{
			ID: "Ranks",
			component: Ranks,
		},
		{
			ID: "Specialities",
			component: Specialities,
		},
	];
	let currentYear = new Date().getFullYear();

	function getNoun(number, one, two, five) {
		let n = Math.abs(number);
		n %= 100;
		if (n >= 5 && n <= 20) {
			return five;
		}
		n %= 10;
		if (n === 1) {
			return one;
		}
		if (n >= 2 && n <= 4) {
			return two;
		}
		return five;
	}
	async function cancel_sp(index) {
		if ($changed) {
			let alert = await customAlert("Выйти без сохранения?");
			if (alert) {
				$saved = "canceled";
				setTimeout(() => {
					$saved = "";
					data[data.field_name][index].active = false;
					$changed = "";
				}, 0);
			}
		} else {
			$saved = "canceled";
			setTimeout(() => {
				$saved = "";
				data[data.field_name][index].active = false;
			}, 0);
		}
	}
	function save_sp(index) {
		$saved = "saved";
		setTimeout(() => {
			data[data.field_name][index].active = false;
			$changed = "";
			$saved = "";
		}, 0);
	}
	function undelete_sp_old(index) {
		data.loadedData[index]["ToDelete"] = false;
		if (!data.loadedData[index]["toUpdate"]) {
			if (data.newData[data.field_name]) {
				data.newData[data.field_name].forEach((specialist, i) => {
					if (specialist["ID"] == data.loadedData[index]["ID"]) {
						data.newData[data.field_name].splice(i, 1);
						data = data;
					}
				});
			}
		}
	}
	function delete_sp_old(index) {
		let check = false;
		data.loadedData[index]["ToDelete"] = true;
		data[data.field_name][index].active = false;
		data.newData[data.field_name].forEach((new_sp) => {
			if (new_sp["ID"] == data.loadedData[index]["ID"]) check = true;
		});
		if (!check) {
			data.newData[data.field_name].push(data.loadedData[index]);
			check = false;
		}
		$isNewDataChanged = true;
	}

	if (data) {
		if (!data.template) {
			data.template = [
				{
					ID: "Input",
					name: "Специалист",
					field_names: ["Name"],
					field_name: "Name",
					placeholder: "ФИО",
					value: "",
				},
				{
					ID: "Specialities",
					name: "Специальность",
					field_names: ["Specialities"],
					field_name: "Specialities",
					value: "",
				},
				{
					ID: "Textarea",
					name: "Описание",
					field_names: ["Text"],
					field_name: "Text",
				},
				{
					ID: "Input",
					type: "number",
					name: "Год начала работы",
					field_names: ["Started"],
					field_name: "Started",
					maxlength: 4,
				},
				{
					ID: "Image",
					name: "Фото",
					field_names: ["Image"],
					field_name: "Image",
				},
				{
					ID: "Ranks",
					name: "Регалии",
					field_names: ["Ranks"],
					field_name: "Ranks",
				},
				{
					ID: "Multiple",
					name: "Образование",
					field_names: ["Education"],
					field_name: "Education",
				},
				{
					ID: "Multiple",
					name: "Квалификация",
					field_names: ["Qualification"],
					field_name: "Qualification",
				},
				{
					ID: "Multiple",
					name: "Сертификаты",
					field_names: ["Certification"],
					field_name: "Certification",
				},
				{
					ID: "Multiple",
					name: "Публикации",
					field_names: ["Publications"],
					field_name: "Publications",
				},
				{
					ID: "Multiple",
					name: "Активности",
					field_names: ["Activities"],
					field_name: "Activities",
				},
				{
					ID: "Multiple",
					name: "Стаж",
					field_names: ["Job"],
					field_name: "Job",
				},
			];
		}

		if (!data[data.field_name]) data[data.field_name] = [];
		if (!data.loadedData) data.loadedData = [];
		if (!data.createdData) data.createdData = [];
		if (!data.req_doctors) data.req_doctors = [];
		if (!data.req_ids) data.req_ids = [];
		if (!data.newData) data.newData = [];
		if (!data.newData[data.field_name]) data.newData[data.field_name] = [];

		if (data.newData) {
			if (data.newData[data.field_name]) {
				if (Array.isArray(data.newData[data.field_name])) {
					data.newData[data.field_name].forEach((raw) => {
						if (Array.isArray(raw)) {
							data.loadedData.push(...raw);
						} else {
							data.loadedData.push(raw);
						}
					});
				}
				if (data.loadedData) {
					data.loadedData.forEach((raw) => {
						$specialistsIDs.push(raw.ID);
					});
				}
				data.loadedData = data.newData[data.field_name];
				data.newData[data.field_name] = [];
				data.loadedData.forEach((specialist) => {
					$specialistsIDs.push(specialist.ID);
					let temp = cloneDeep(data.template);
					temp.forEach((block) => {
						if (!block.newData) block.newData = [];
						if (block.field_names) {
							block.field_names.forEach((raw) => {
								block.newData[raw] = specialist[raw];
							});
						}
					});
					temp.name = "Редактировать специалиста";
					data[data.field_name].push(temp);
				});
			}
		}
	}
	$: if ($specialistsAddArr) {
		if (data && data.loadedData) {
			data.loadedData = data.loadedData.concat($specialistsAddArr);
		}
	}
</script>

{#if data}
	<div class="specialists">
		{#if data[data.field_name]}
			{#each data[data.field_name] as specialist, index}
				<div class="specialists__item specialist">
					<div class="specialist__bg">
						{#if data.loadedData[index]["ToDelete"]}
							<div class="specialist__bg-holder" />
						{/if}
						{#if $SpecialistPremodDone}
							<span>Добавлен</span>
						{:else}
							<span>На модерации</span>
						{/if}
						{#if data.loadedData[index]["Can"]}
							<span
								class="specialist__bg-edit"
								on:click|preventDefault={() =>
									(specialist.active = "1")}
								>Редактировать</span
							>
						{/if}
					</div>

					<div class="modal" class:active={specialist.active}>
						<div
							class="modal__bg"
							on:click={() => {
								cancel_sp(index);
							}}
						/>
						<div class="modal__body">
							<i
								class="fas fa-times modal__cross"
								on:click={() => {
									cancel_sp(index);
								}}
							/>
							{#if specialist.name}
								<span class="modal__title"
									>{specialist.name}</span
								>
							{/if}
							<div
								class="modal__content scrollbar-white {$isMobile
									? 'mobile'
									: 'not_mobile'}"
							>
								{#each specialist as block, j}
									{#each componentList as component}
										{#if block.ID == component.ID}
											<div class="modal__item">
												<svelte:component
													this={component.component}
													{block}
													{data}
													{index}
													{j}
													type={""}
												/>
											</div>
										{/if}
									{/each}
								{/each}
							</div>
							<div class="modal__buttons">
								<span
									class="modal__button modal__save"
									on:click={() => {
										save_sp(index);
									}}>Ок</span
								>
								<span
									class="modal__button modal__cancel"
									on:click={() => {
										cancel_sp(index);
									}}>Отмена</span
								>
								<span
									class="modal__button modal__delete"
									on:click={() => {
										delete_sp_old(index);
									}}>Удалить</span
								>
							</div>
						</div>
					</div>

					<div class="specialist__preview">
						{#if data.loadedData[index]["Image"]}
							<div class="specialist__img">
								<img
									src={localUrl(
										"https://topdent.ru",
										data.loadedData[index]["Image"]
									)}
									alt=""
								/>
								{#if data.loadedData[index]["Rating"] && data.loadedData[index]["Rating"] != "0.00"}
									<span class="specialist__rating"
										><i class="fas fa-star" />{data
											.loadedData[index]["Rating"]}</span
									>
								{/if}
							</div>
						{:else}
							<div
								class="specialist__img specialist__img-blank"
							/>
						{/if}
						<div class="specialist__content">
							{#if data.loadedData[index]["ToDelete"]}
								<i
									class="fas fa-check specialist__check"
									on:click={() => {
										undelete_sp_old(index);
									}}
								/>
							{:else}
								<i
									class="fas fa-trash specialist__delete"
									on:click={() => {
										delete_sp_old(index);
									}}
								/>
							{/if}
							{#if data.loadedData[index]["Name"]}
								<div class="specialist__name">
									<span>{data.loadedData[index]["Name"]}</span
									>
								</div>
							{/if}
							{#if data.loadedData[index]["Started"]}
								<span class="specialist__standing"
									>{"Стаж " +
										(currentYear -
											data.loadedData[index]["Started"]) +
										" " +
										getNoun(
											currentYear -
												data.loadedData[index][
													"Started"
												],
											"год",
											"года",
											"лет"
										)}</span
								>
							{/if}
						</div>
					</div>
				</div>
			{/each}
		{/if}
	</div>
{/if}

<style lang="scss">
	.specialists {
		max-width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin: 0 -20px -20px 0;

		@media (max-width: 991px) {
			flex-direction: column;
		}

		&__item {
			display: flex;
			min-height: 152px;
			flex-shrink: 0;
			flex-basis: calc(50% - 20px);
			border-radius: 20px;
			margin: 0 20px 20px 0;

			@media (max-width: 991px) {
				flex-basis: unset;
				margin: 0 0 20px 0;
			}
		}
		&__item {
			box-shadow: rgba(61, 63, 85, 0.396) 0px 0px 1px,
				rgba(61, 63, 85, 0.047) 0px 2px 15px;

			.modal__content {
				padding: 0 !important;
			}
		}
	}
	.specialist {
		padding: 16px 12px 18px 12px;
		overflow: hidden;
		max-width: 100%;
		position: relative;
		@media (max-width: 700px) {
			padding: 10px 8px;
		}
		&__bg {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: #bacbd5ad;
			display: flex;
			align-items: flex-end;
			justify-content: flex-end;
			padding: 20px;
			z-index: 1;
			flex-direction: column;

			&-holder {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				background: rgba(255, 0, 0, 0.11);
				display: flex;
				align-items: center;
				justify-content: center;
				z-index: 10;
				&::before,
				&::after {
					content: "";
					height: 100%;
					width: 2px;
					background: var(--color-4);
					display: flex;
					position: absolute;
				}
				&::before {
					transform: rotate(45deg);
				}
				&::after {
					transform: rotate(-45deg);
				}
			}

			> span {
				font-size: 16px;
				padding: 5px 10px;
				background: #fff;
				border-radius: 8px;
				color: gray;
			}
			&-edit {
				margin-top: 10px;
				color: var(--text-main-1) !important;
				background: var(--color-1) !important;
				cursor: pointer;
			}
		}

		transition: background-color 0.1s ease-in;
		&:hover {
			background-color: #f9fafb;
		}

		&__delete,
		&__check {
			z-index: 100;
			position: absolute;
			right: 0;
			height: 0;
			width: 0;
			font-size: 10px;
			color: #979797;
			padding: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			cursor: pointer;
			border: solid 1px #979797;
			&:hover {
				color: var(--color-1);
			}
		}

		&__rating {
			position: absolute;
			bottom: 0;
			right: 0;
			color: #ffaa30;
			font-size: 13px;
			line-height: 20px;
			padding: 4px;
			background: #fff;
			border-top-left-radius: 10px;
			font-size: 13px;
			font-weight: bold;

			> i {
				margin-right: 4px;
			}
		}

		&__img {
			display: flex;
			flex-shrink: 0;
			max-height: 110px;
			max-width: 110px;
			width: 100%;
			height: 100%;
			margin-right: 12px;
			align-self: flex-start;
			position: relative;

			@media (max-width: 700px) {
				max-height: 80px;
				max-width: 80px;
				position: absolute;
			}

			&-blank {
				border-radius: 20px;
				border: solid 1px var(--border-gray-1);
			}

			> img {
				object-fit: cover;
				width: 100%;
				height: 100%;
				border-radius: 20px;
			}
		}

		&__preview {
			display: flex;
			width: 100%;
		}

		&__content {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			position: relative;
		}

		&__name {
			font-size: 16px;
			font-weight: 700;
			line-height: 24px;
			padding-right: 32px;

			@media (max-width: 700px) {
				padding-left: 90px;
			}
		}

		&__standing {
			padding-right: 32px;
			@media (max-width: 700px) {
				padding-left: 90px;
			}
		}
	}
</style>
